import React, { useState } from 'react';
import { connect } from 'react-redux';
import DefaultFeedback from '../../utils/feedback/defaultFeedback';
import ListAnimation from '../../../utils/animations/list';
const mapStateToProps = (state) => {
	const { rightFeedbackProps, answerCount } = state.rootReducer.testPageDetails;

	return {
		rightFeedbackProps,
		answerCount,
	};
};

const McqCorrect = ({
	rightFeedbackProps: {
		feedbackChoices,
		feedbackImageChoices,
		feedbackAudioChoices,
		defaultFeedback,
		correctAnswer,
	},
	marking,
}) => {
	const [showMore, setShowMore] = useState(false);
	let moreChoices = '';
	if (!!feedbackChoices) {
		if (!!feedbackChoices && Object.keys(feedbackChoices).length > 0) {
			moreChoices = Object.keys(feedbackChoices).map(function (choice) {
				if (
					feedbackChoices[choice] === '' ||
					feedbackChoices[choice] === correctAnswer
				) {
					return false;
				}
				let RightChoice = feedbackChoices[choice];
				if (
					feedbackImageChoices[choice] !== '' &&
					feedbackImageChoices[choice] !== 'None'
				) {
					RightChoice = <img src={feedbackImageChoices[choice]} alt="" />;
				}

				if (
					!!feedbackAudioChoices &&
					!!feedbackAudioChoices[choice] &&
					feedbackAudioChoices !== 'None'
				) {
					RightChoice = (
						<audio controls controlsList="nodownload">
							<source src={feedbackAudioChoices[choice]} alt="" />
						</audio>
					);
				}

				return <li key={`more_${choice}`}>{RightChoice}</li>;
			});
		}
	}

	return (
		<span>
			<ListAnimation>
				<ul className="no-mouse-events">
					<li className={marking}>{correctAnswer}</li>
					{!!defaultFeedback && (
						<DefaultFeedback defaultFeedback={defaultFeedback} />
					)}
				</ul>
			</ListAnimation>
			{showMore && (
				<ListAnimation>
					<ul>{moreChoices}</ul>
				</ListAnimation>
			)}
			{!moreChoices.every((x) => !x) && (
				<button
					onClick={() => setShowMore((x) => !x)}
					className="btn btn-xs btn-info mar-rgt mar-btm pull-right"
				>
					{showMore ? 'View less options' : 'View all options'}
				</button>
			)}
		</span>
	);
};

export default connect(mapStateToProps)(McqCorrect);
